import axios from 'axios';
import i18n from 'i18next';
import { ACCESS_TOKEN, I18_NEXT_LNG, LANGUAGE } from '../../store/types';
import { toastError } from '../../components/toastify';
import { resetStore } from '../../store';
import { getStorage, LocalStorage } from '../../utils/storage';



const axiosInstance = axios.create({
  // timeout: 10000, // 请求超时时间
  baseURL: process.env.REACT_APP_API_BASE_URL
});

// request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = getStorage(ACCESS_TOKEN);
    if (accessToken) {
      // config.headers.Authorization = accessToken;
      config.headers['X-Access-Token'] = accessToken; // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    // 接口頭部設置多語言CODE
    // config.headers['X-Language-Code'] = 'zh_CN';
    if(['undefined'].includes(getStorage(I18_NEXT_LNG))) {
      config.headers['X-Language-Code'] = LANGUAGE.tw;
    };
    config.headers['X-Language-Code'] = LocalStorage.get(I18_NEXT_LNG) || LANGUAGE.tw;

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    const { code, status, data, message, msg } = response;
    if (response && (code === 200 || status === 200)) {
      return response.data;
    }
    throw new Error(msg || message || 'error');
  },
  (error) => {
    // const navigator = useNavigate();
    // error.response.data
    const accessToken = window.sessionStorage.getItem(ACCESS_TOKEN);
    const { status, data } = error.response || {};
    const { msg } = data || {};
    switch (status) {
      case 400:
        console.error(msg || '請地址不存在!');
        break;
      case 401:
        resetStore();
        toastError(msg || '未授权，请重新登录!');
        console.error('未授权，请重新登录!');
        if (accessToken) {
          window.sessionStorage.clear();
          window.location.reload();
        }
        // window.location.reload();
        break;
      case 403:
        toastError(msg || '拒绝访问!');
        console.error('拒绝访问!');
        break;
      case 404:
        toastError(msg || '很抱歉，资源未找到!');
        console.error('很抱歉，资源未找到!');
        break;
      case 408:
        toastError(msg || '请求超时!');
        console.error('请求超时!');
        break;
      case 500:
        toastError(msg || '登录已过期，請重新登錄!')
        console.error('Token失效或者登录已过期，請重新登錄!');
        if (accessToken) {
          window.sessionStorage.clear();
          window.location.reload();
        }
        break;
      case 501:
        toastError(msg || '服务未实现!')
        console.error('服务未实现!');
        break;
      case 502:
        toastError(msg || '网关错误!');
        console.error('网关错误!');
        break;
      case 503:
        toastError(msg || '服务不可用!');
        console.error('服务不可用!');
        break;
      case 504:
        toastError(msg || '网络超时!');
        console.error('网络超时!');
        break;
      default:
        break;
    };
    Promise.reject((error.response && error.response.data) || 'Something went wrong!').then(
      (r) => {}
    );
  }
);

export default axiosInstance;
